import { GET_USER, CLEAR_USER } from '../constants';
import { lsSetItem, lsRemoveItem } from '../../utils';
import { STYLIST_SALONID } from '../../pages/SalonConsultationPage/localStorageKeys';

export default (state = {}, action) => {
  switch (action.type) {
    case `${GET_USER}_PENDING`:
      return state;
    case `${GET_USER}_FULFILLED`: {
      const data = action.payload;
      lsSetItem(STYLIST_SALONID, data.user.salonId);
      return {
        ...state,
        ...data.user,
      };
    }
    case `${GET_USER}_REJECTED`:
      return state;
    case `${CLEAR_USER}`: {
      lsRemoveItem(STYLIST_SALONID);
      return {};
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/user.js